import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 按需引入
import './utils/ELement'

// 引入写好的定制主题色
import './styles/element-variables.scss'
// 引入normalize.css
import 'normalize.css'
import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// 完整引入
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.use(VueQuillEditor /* { default global options } */)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
